import React from "react";
import SSIM from "./ssim/SSIM";
import { useAuth0 } from '@auth0/auth0-react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";


function Header(props) {
  const { loginWithRedirect, logout, user, isAuthenticated, isLoading } = useAuth0();
  let api_url = 'https://api.aviprice.com'

  return (
    <Router>
      <div className="d-flex justify-content-end align-items-center p-3">
        {isLoading && <span className="me-2">Loading auth...</span>}
        {!isAuthenticated && !isLoading && (
          <button className="btn btn-primary btn-sm" onClick={() => loginWithRedirect()}>
            Log in
          </button>
        )}
        {isAuthenticated && (
          <>
            <span className="me-3">{user?.name || user?.email}</span>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => logout({ returnTo: window.location.origin })}
            >
              Log out
            </button>
          </>
        )}
      </div>
      <Switch>
        <Route path="/">
          {isAuthenticated ? (
            <SSIM api_url={api_url} />
          ) : (
            <div className="container py-5">
              <h3>Please log in to use the SSIM app.</h3>
            </div>
          )}
        </Route>
      </Switch>
    </Router>
  )
}

export default Header